import Pagination from "@/components/pagination"
import { useEffect } from "react"
import SearchBar from "@/routes/admin/_components/search-bar"
import { useState } from "react"
import TableHeader from "../_components/table/table-header"
import TableData from "../_components/table/table-data"
import { GROUP_COLUMNS } from "./admin-group-const"
import { groupStore } from "./admin-group-store"
import ActionToolbar from "../_components/action-toolbar"
import CreateGroupForm from "./_components/create-group-form"
import { toast } from "sonner"
import { deleteGroupAPI, updateGroupAPI } from "@/apis/admin-api"
import { useMemo } from "react"
import CustomButton from "./_components/custom-button"
import { useToggleState } from "@/hooks/use-toggle-state"
import AptSelectModal from "./_components/apt-select-modal"

const AdminGroupPage = () => {
  const { list, pagination, updateQuery, apiAction } = groupStore()
  useEffect(() => {
    groupStore.getState().apiAction()
  }, [])

  const [selectedGroup, setSelectedGroup] = useState({
    id: null,
    group_name: ""
  })

  const [keyword, setKeyword] = useState("")
  const [changedMap, setChangedMap] = useState({})
  const [isFormOpen, setIsFormOpen] = useState(false)

  const displayList = useMemo(() => {
    return list.map((item) => ({
      ...item,
      ...changedMap[item.id]
    }))
  }, [list, changedMap])

  const changeField = (groupId, key, value) => {
    const origin = list.find((v) => v.id === groupId)
    if (!origin) return

    const originValue = origin[key] ?? null
    const changedValue = value ?? null

    setChangedMap((prev) => {
      const next = { ...prev }

      if (originValue === changedValue) {
        if (next[groupId]) {
          delete next[groupId][key]

          if (Object.keys(next[groupId]).length === 0) {
            delete next[groupId]
          }
        }

        return next
      }

      next[groupId] = {
        ...next[groupId],
        [key]: changedValue
      }

      return next
    })
  }

  const updateGroup = async () => {
    const changedList = Object.entries(changedMap).map(([id, changes]) => ({
      id: Number(id),
      ...changes
    }))

    if (!changedList.length) {
      return toast.info("변경된 내용이 없습니다.")
    }

    try {
      await updateGroupAPI(changedList)

      toast.success("그룹 정보가 수정되었습니다.")

      await apiAction()
      setChangedMap({})
    } catch (err) {
      toast.error(err?.response?.data?.detail || "그룹 수정에 실패했습니다.")
    }
  }

  const toggleCreateForm = () => {
    setIsFormOpen((prev) => !prev)
  }

  const rowGridClass = "grid grid-cols-[100px_1fr_2fr_150px_150px]"

  const onSearch = async () => {
    await updateQuery({ keyword })
  }

  const deleteGroup = async () => {
    if (!selectedGroup.id) {
      return toast.info("삭제할 그룹을 선택해 주세요.")
    }

    const msg = `'${selectedGroup.group_name}' 그룹을 삭제하시겠습니까?`
    if (!confirm(msg)) return

    const { success } = await deleteGroupAPI({
      group_id: selectedGroup.id
    })
    if (success) {
      toast.success(`${selectedGroup.group_name} 그룹이 삭제되었습니다.`)
      await apiAction()
    }

    // setSelectedGroup({
    //   id: null,
    //   group_name: ""
    // })
  }

  const { show, toggle, close } = useToggleState(false)
  const [targetGroup, setTargetGroup] = useState(null)

  return (
    <section className="flex-1 flex flex-col">
      <article className="flex items-center justify-between">
        <SearchBar
          placeholder={"ID, 유저명으로 검색"}
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
          onSubmit={onSearch}
        />

        <ActionToolbar
          onCreate={toggleCreateForm}
          isFormOpen={isFormOpen}
          onUpdate={updateGroup}
          hasChanged={Object.keys(changedMap).length > 0}
          onDelete={deleteGroup}
        />
      </article>

      {isFormOpen && <CreateGroupForm successAction={() => setIsFormOpen(false)} />}

      <TableHeader className={rowGridClass} columns={GROUP_COLUMNS} />

      <TableData
        datalist={displayList}
        columns={GROUP_COLUMNS}
        rowKey="id"
        className={rowGridClass}
        selected={selectedGroup}
        rowClick={(item) => {
          setSelectedGroup({
            id: item.id,
            group_name: item.group_name
          })
        }}
        onChange={changeField}
        customRenders={{
          codes: (item) => (
            <CustomButton
              item={item}
              onClick={() => {
                toggle()
                setTargetGroup(item)
              }}
            />
          )
        }}
      />

      {show && (
        <AptSelectModal
          group={targetGroup}
          onClose={close}
          onSubmit={async (codes) => {
            try {
              await updateGroupAPI([
                {
                  id: targetGroup.id,
                  codes
                }
              ])

              toast.success("아파트 목록이 수정되었습니다.")

              close()
              await apiAction()
            } catch (err) {
              toast.error(err?.response?.data?.detail || "아파트 목록 수정에 실패했습니다.")
            }
          }}
        />
      )}

      <footer className="mt-auto">
        <Pagination
          currentPage={pagination.page}
          totalPages={Math.ceil(pagination.total / pagination.size)}
          onChange={(p) => updateQuery({ page: p })}
          activeStyle="bg-toicos-navy"
        />
      </footer>
    </section>
  )
}

export default AdminGroupPage
